:host {
  display: block;
  --se-success: #008a16;
}

.ffn-wrapper {
  background-color: #ffffff;
  margin: 0px 20px 20px 4px;

  .ffn-header-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-decoration: none;
    background-color: #ffffff;
    border-bottom: none;
    cursor: pointer;
    padding: 0 20px;
    border-bottom: 1px solid var(--se-divider, #e6e6e6);

    .ffn-header-title {
      font-size: 14px;
      font-weight: 700;
      line-height: 20px;
      text-align: left;
      margin: 16px 6px 15px 0;

      &::first-letter {
        text-transform: uppercase;
      }
    }

    .collapse-arrow {
      height: 8px;
      width: 8px;
      transform: rotate(-225deg);
      border-top: 1px solid;
      border-right: 1px solid rgb(51, 51, 51);
      transition: 0.2s;
      margin-bottom: 2px;

      &.rotated {
        transform: rotate(-45deg);
        transform-origin: 100% 50%;
        margin-bottom: 0px;
      }
    }
  }

  .ffn-header-label-wraper {
    display: flex;
    align-items: center;
  }

  .ffn-header-label {
    padding: 15px 0px 6px 10px;
  }

  .ffn-body-wrapper {
    overflow: hidden;
    opacity: 1;
    height: auto;
    transition:
      height 0.4s,
      opacity 0.4s;
    padding: 6px 20px;

    &.closed {
      height: 0px;
      opacity: 0;
      transition:
        height 0.4s,
        opacity 0.4s;
      padding: 0 20px 0 20px;
    }

    .ffn-checkbox-list-wrapper {
      display: flex;
      flex-direction: column;
      padding: 0;

      .hidden-filter {
        display: none;
      }

      .filtered-hide {
        display: none;
      }
    }

    .ffn-filters-input {
      position: relative;
      padding: 0 0 6px 0;

      input.ffn-input {
        width: calc(100% - 12px);
        display: flex;
        height: 44px;
        border-radius: 2px;
        border: 1px solid var(--srp-greyscale-se-dark-grey-626469, #626469);
        padding-left: 12px;

        &::-webkit-input-placeholder,
        &::-moz-placeholder,
        &:-ms-input-placeholder,
        &:-moz-placeholder {
          font-size: 16px;
          font-weight: 400;
          line-height: 22px;
          text-align: left;
          height: 44px;
          padding-left: 12px;
          color: var(--srp-greyscale-se-dark-grey-626469, #626469);
        }
      }

      button.loupe-search {
        position: absolute;
        right: 1px;
        top: 14px;
        height: 44px;
        width: 44px;
        border: none;
        background: #ffffff;
      }

      button.clear-input {
        position: absolute;
        right: 45px;
        top: 14px;
        height: 44px;
        width: 24px;
        border: none;
        background: #ffffff;
      }
    }

    .ffn-expand-button {
      span.filters-collapse-btn {
      }
    }
  }
}

.ffn-qds-input {
  padding-top: 6px;
  display: block;
}

.ffn-view-more-btn {
  --qds-control-input-padding-horizontal: 0px;
  margin-bottom: 6px;
}
